<template>
  <v-layout wrap>
    <v-btn
      :icon="button_as_icon"
      :small="small"
      flat
      color="success"
      @click="runExport()"
    >
      <v-icon small :class="button_as_icon ? '' : 'pr-2'"
        >mdi-file-excel</v-icon
      >
      {{ button_label }}
    </v-btn>
  </v-layout>
</template>

<script>
import XLSX from "xlsx";
import pluralize from "pluralize";

export default {
  props: {
    button_as_icon: false,
    button_label: {
      type: String,
      required: false,
      default: "Export to xlsx",
    },
    filename: {
      type: String,
      required: false,
      default: "table_export.xlsx",
    },
    sheetsLabels: {
      type: Array,
      required: false,
      default: () => [],
    },
    sheetsData: {
      type: Array,
      required: false,
      default: () => [],
    },
    propsControl: {
      type: Boolean,
      required: false,
      default: false,
    },
    exportTriggerKey: {
      type: Number,
      required: false,
      default: 0,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      pluralize,
    };
  },
  methods: {
    camelize(str, sep = "", plural = false) {
      return pluralize(
        str
          .split("_")
          .map((w) => w.replace(/./, (m) => m.toUpperCase()))
          .join(sep),
        plural ? 2 : 1
      );
    },
    runExport() {
      if (this.propsControl) {
        /*
          If the export is triggered by a pros, just emit an event to
          allow the parent component to fetch data
        */
        this.$emit("runExport");
      } else {
        /*
          Otherwise, directly build the file
        */
        this.exportXLSX();
      }
    },
    exportXLSX() {
      console.log(this.sheetsData)
      var file = XLSX.utils.book_new();
      this.sheetsLabels.forEach((sheet, index) => {
        var page = XLSX.utils.json_to_sheet(this.sheetsData[index]);
        XLSX.utils.book_append_sheet(file, page, sheet);

        //Tweak headers
        var range = XLSX.utils.decode_range(page["!ref"]);
        for (var C = range.s.r; C <= range.e.r; ++C) {
          var cell = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
          if (!page[cell]) continue;
          page[cell].v = this.camelize(page[cell].v, " ");
        }

        // Trying to adjust the column widths
        var wscols = [];
        var max_length = 0;
        if (this.sheetsData[index].length > 0) {
          Object.keys(this.sheetsData[index][0]).forEach((header) => {
            max_length = header.length;

            this.sheetsData[index].forEach((data) => {
              if (data[header] && data[header].length > max_length)
                max_length = data[header].length;
            });

            wscols.push({ wpx: Math.min(max_length, 200) * 7 });
          });
        }
        // this.sheetsData.forEach(data => {
        // });
        // {wpx: 100},{wpx: 200}

        page["!cols"] = wscols;
      });

      //Excel file
      XLSX.writeFile(file, this.filename);
    },
  },
  watch: {
    exportTriggerKey() {
      if (this.propsControl) this.exportXLSX();
    },
  },
};
</script>
